// extracted by mini-css-extract-plugin
module.exports = {"pagination__current":"bv_jn","pagination__placeholder":"bv_jp","pagination__totalSeparator":"bv_jq"};